import type { DocumentLocale } from './documentLocale';

export interface LegalDocumentChromeStrings {
    loading: string;
    lastUpdated: string;
    privacyPolicyTitle: string;
    termsOfUseTitle: string;
    privacyPolicyLoadFailed: string;
    termsOfUseLoadFailed: string;
    versionNotSpecified: string;
    documentNotFound: string;
}

const chromeByLocale: Record<DocumentLocale, LegalDocumentChromeStrings> = {
    tr: {
        loading: 'Yükleniyor...',
        lastUpdated: 'Son güncelleme:',
        privacyPolicyTitle: 'Gizlilik Politikası',
        termsOfUseTitle: 'Kullanım Koşulları',
        privacyPolicyLoadFailed: 'Gizlilik politikası yüklenemedi.',
        termsOfUseLoadFailed: 'Kullanım koşulları yüklenemedi.',
        versionNotSpecified: 'Belge sürümü belirtilmedi.',
        documentNotFound: 'Belge bulunamadı.',
    },
    en: {
        loading: 'Loading...',
        lastUpdated: 'Last updated:',
        privacyPolicyTitle: 'Privacy Policy',
        termsOfUseTitle: 'Terms of Use',
        privacyPolicyLoadFailed: 'Failed to load privacy policy.',
        termsOfUseLoadFailed: 'Failed to load terms of use.',
        versionNotSpecified: 'Document version not specified.',
        documentNotFound: 'Document not found.',
    },
};

export function getLegalDocumentChrome(
    locale: DocumentLocale
): LegalDocumentChromeStrings {
    return chromeByLocale[locale];
}
